/* Naturealm Journal: instant filtering on the base blog URL. Tag URLs fall back to normal links. */
(function () {
  var root = document.querySelector('[data-nj]');
  if (!root) return;

  var PAGE = 12;
  var tagged = root.getAttribute('data-tagged') === 'true';
  var cards = Array.prototype.slice.call(root.querySelectorAll('.nj-card'));
  var moreBtn = root.querySelector('[data-nj-more]');
  var countEl = root.querySelector('[data-nj-count]');
  var titleEl = root.querySelector('[data-nj-title]');
  var clearEl = root.querySelector('[data-nj-clear]');
  var emptyEl = root.querySelector('[data-nj-empty]');
  var feed = root.querySelector('#nj-feed');
  var controls = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
  var limit = PAGE;

  function tagsOf(card) { return ' ' + (card.getAttribute('data-tags') || '') + ' '; }
  function plural(n) { return n + (n === 1 ? ' post' : ' posts'); }

  // Goal counts (based on the posts on this page)
  Array.prototype.forEach.call(root.querySelectorAll('[data-count]'), function (el) {
    var h = el.getAttribute('data-count');
    var n = cards.filter(function (c) { return tagsOf(c).indexOf(' ' + h + ' ') > -1; }).length;
    el.textContent = n ? plural(n) : '';
  });

  // Newsletter: subscribe straight to the Klaviyo list. Falls back to Shopify's form if anything fails.
  var news = root.querySelector('[data-kl-list]');
  var newsForm = news && news.querySelector('form');
  if (newsForm && news.getAttribute('data-kl-list') && news.getAttribute('data-kl-key')) {
    newsForm.addEventListener('submit', function (e) {
      var input = newsForm.querySelector('input[type="email"]');
      var btn = newsForm.querySelector('button[type="submit"]');
      var msg = newsForm.querySelector('[data-kl-msg]');
      if (!input || !input.value || newsForm.getAttribute('data-kl-fallback')) return;
      e.preventDefault();
      if (btn) { btn.disabled = true; btn.textContent = 'Subscribing…'; }
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(news.getAttribute('data-kl-key')), {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Blog: Naturealm Journal',
          profile: { data: { type: 'profile', attributes: { email: input.value.trim(), properties: { signup_source: 'Naturealm Journal' } } } }
        }, relationships: { list: { data: { type: 'list', id: news.getAttribute('data-kl-list') } } } } })
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
        newsForm.innerHTML = '<p class="nj-news__ok" role="status">You’re in. Watch your inbox.</p>';
      }).catch(function () {
        newsForm.setAttribute('data-kl-fallback', '1');
        if (btn) { btn.disabled = false; btn.textContent = 'Subscribe'; }
        if (msg) msg.textContent = 'Something went wrong. Please try again.';
      });
    });
  }

  if (tagged) {
    // Server already filtered. Just paginate what is here.
    paginate(cards);
    if (moreBtn) moreBtn.addEventListener('click', function () { limit += PAGE; paginate(cards); });
    return;
  }

  var params = new URLSearchParams(window.location.search);
  var state = { type: params.get('type') || '', goal: params.get('goal') || '', mushroom: params.get('mushroom') || '' };

  function labelFor(kind, value) {
    var el = root.querySelector('[data-filter="' + kind + '"][data-value="' + value + '"]');
    if (!el) return '';
    var l = el.querySelector('.nj-goal__label');
    return (l ? l.textContent : el.textContent).trim();
  }

  function paginate(list) {
    cards.forEach(function (c) { c.classList.add('is-hidden'); });
    list.forEach(function (c, i) { if (i < limit) c.classList.remove('is-hidden'); });
    if (moreBtn) moreBtn.hidden = list.length <= limit;
    if (countEl) countEl.textContent = plural(list.length);
    if (emptyEl) emptyEl.hidden = list.length > 0;
  }

  function apply(push) {
    var want = [state.type, state.goal, state.mushroom].filter(Boolean);
    var matches = cards.filter(function (c) {
      var t = tagsOf(c);
      return want.every(function (h) { return t.indexOf(' ' + h + ' ') > -1; });
    });
    paginate(matches);

    controls.forEach(function (el) {
      var on = (state[el.getAttribute('data-filter')] || '') === el.getAttribute('data-value');
      el.classList.toggle('is-on', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var parts = [];
    if (state.goal) parts.push(labelFor('goal', state.goal));
    if (state.mushroom) parts.push(labelFor('mushroom', state.mushroom));
    var typeLabel = state.type ? labelFor('type', state.type) : '';
    if (titleEl) titleEl.textContent = parts.length ? parts.join(' · ') : (typeLabel || 'All posts');
    if (clearEl) clearEl.hidden = !want.length;

    if (push) {
      var q = new URLSearchParams();
      ['type', 'goal', 'mushroom'].forEach(function (k) { if (state[k]) q.set(k, state[k]); });
      var url = window.location.pathname + (q.toString() ? '?' + q.toString() : '');
      window.history.replaceState(null, '', url);
    }
  }

  controls.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var kind = el.getAttribute('data-filter');
      var val = el.getAttribute('data-value');
      state[kind] = (kind !== 'type' && state[kind] === val) ? '' : val;
      limit = PAGE;
      apply(true);
      if (feed && !feed.contains(el)) {
        var top = feed.getBoundingClientRect().top;
        if (top > window.innerHeight * 0.6 || top < 0) feed.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  if (clearEl) clearEl.addEventListener('click', function (e) {
    e.preventDefault();
    state = { type: '', goal: '', mushroom: '' };
    limit = PAGE;
    apply(true);
  });

  if (moreBtn) moreBtn.addEventListener('click', function () { limit += PAGE; apply(false); });

  apply(false);
})();
